<template>
  <div class="lbv-update-parameters animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card v-if="$store.getters.roleID === '4'">
          <h1 class="lbv-page-title updateParameters">
            Update Parameters
          </h1>
          <div class="updateParametersInputs">
            <p>This page is provided so that you can update the parameters of a single device. You can stack up as many as you like.</p>
            <p>Please remember - For SigFox devices they are only able to receive 4 parameters per day and these parameter will only be sent when the device sends an acknowledged message.</p>
            <form @submit.prevent="updateParam">
              <b-row>
                <b-col cols="2">
                  <label>LeakBot ID:</label>
                </b-col>
                <b-col cols="10">
                  <input
                    v-model="leakBotID"
                    type="text"
                    class="form-control full-width"
                    @change="populateParameter"
                  >
                </b-col>
              </b-row>
              <b-row class="push-down">
                <b-col cols="2">
                  <label>Logging (sigfox only):</label>
                </b-col>
                <b-col cols="10">
                  <b-form-select
                    v-model="loggingType"
                    class="full-width"
                  >
                    <option :value="3">
                      Leave Unchanged
                    </option>
                    <option value="1">
                      Turn Off
                    </option>
                    <option value="2">
                      Turn On
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="push-down">
                <b-col cols="2">
                  <label>Parameter:</label>
                </b-col>
                <b-col cols="10">
                  <select
                    v-model="parameterSelector"
                    class="form-control full-width"
                    @change="updateLegend"
                  >
                    <option
                      v-if="parameterList !== null"
                      :value="null"
                      disabled
                    >
                      Please select an option
                    </option>
                    <option
                      v-for="parameter in parameterList"
                      :value="{ id: parameter.parameterNumber, name: parameter.parameterName, minVal: parameter.minVal, maxVal: parameter.maxVal }"
                    >
                      {{ parameter.parameterNumber }} - {{ parameter.parameterName }}
                    </option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="push-down">
                <b-col cols="2">
                  <label>Parameter Value ({{ parameterValueLabelMin }} , {{ parameterValueLabelMax }}):</label>
                </b-col>
                <b-col cols="10">
                  <input
                    v-model="parameterValue"
                    type="text"
                    class="form-control full-width"
                  >
                </b-col>
              </b-row>
              <button
                type="submit"
                class="btn btn-primary parameterUpdate"
              >
                <span>Queue Parameter Update</span>
              </button>
            </form>
          </div>
        </b-card>
      </div>
    </div>
    <b-alert
      class="reportErr"
      :show="errorString != &quot;&quot;"
      variant="danger"
    >
      {{ errorString }}
    </b-alert>
  </div>
</template>

<script>
import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'

export default {
  name: 'UpdateParameters',
  data: function () {
    return {
      errorString: '',
      leakBotID: null,
      loggingType: 3,
      parameterSelector: null,
      parameterValue: null,
      parameterList: null,
      parameterValueLabelMin: 0,
      parameterValueLabelMax: 0
    }
  },
  methods: {
    handleError (error) {
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    },
    populateParameter (event) {
      // entering leakBotId populate the Parameter dropdown
      if (this.leakBotID !== null) {
        // get the parameter list
        this.$store.dispatch(APIEvent.FETCH_PARAMETERS, {leakbot_id: this.leakBotID})
          .then((response) => {
            // populate the parameter dropdown
            if (response.data.hasOwnProperty('record')) {
              this.parameterList = response.data.record
            }
          })
          .catch(this.handleError)
      }
    },
    updateLegend () {
      this.parameterValueLabelMin = this.parameterSelector.minVal
      this.parameterValueLabelMax = this.parameterSelector.maxVal
    },
    updateParam () {
      let options = {}
      // validate the parameter - in range
      if (this.parameterValue !== null) {
        if ((this.parameterValue < this.parameterValueLabelMin) && (this.parameterValue > this.parameterValueLabelMax)) {
          EventBus.$emit(StatusBarEvent.ERROR, 'Parameter value out of range')
        } else {
          options.leakbot_id = this.leakBotID
          options.transmit = this.loggingType.toString()
          options.parameter_number = this.parameterSelector.id
          options.parameter_value = this.parameterValue
          this.$store.dispatch(APIEvent.CREATE_PARAMETER_UPDATE, options)
            .then((res) => {
              /*
              LeakBot ID FAKED9 has parameter update queued with following details -
              Logging - Leave Unchanged
              Parameter - 1 - LbDeviceThreshold
              Parameter Value - 2
              */
              if (res.data.hasOwnProperty('ack')) {
                EventBus.$emit(StatusBarEvent.SUCCESS, `LeakBot ID ${this.leakBotID} has parameter update queued with following details
                - Logging - ${this.loggingType}
                Parameter - ${this.parameterSelector.name}
                Parameter Value - ${this.parameterValue}`)
              }
            })
            .catch(this.handleError)
        }
      }
      // submit user inputs
    }
  }
}
</script>
<style media="screen">

  .lbv-update-parameters .updateParametersInputs label {
    font-size: 0.8rem;
    float: left;
    margin-right: 4px;
    margin-top: 9px;
    font-weight: bold;
  }

  .updateParametersInputs .push-down {
    margin-top: 1rem;
  }

  .updateParametersInputs .form-control {
    width: 200px;
    border-radius: 8px
  }

  .parameterUpdate {
    float: left;
    border-radius: 8px;
    margin-top: 1.5rem;
  }

</style>
